import React, {Component, Fragment} from 'react';
import {observer} from 'mobx-react';
import './styles.scss';
import {isMobile} from "../../utils/screenUtility";

@observer
class VideoAskToJoin extends Component {

    render() {
        const {onClickRemote} = this.props;
        if (isMobile()){
            return null;
        }
        return (
            <Fragment>
                <div className="remote remote-hover" data-testid="remote-video" onClick={onClickRemote}/>
                <div className="remote remote-musico"/>
            </Fragment>
        );
    }
}

export default VideoAskToJoin;
